import React from 'react';
import TraceTileFallback from '@/finsight/ui/components/trace/TraceTile/TraceTileFallback';
import { UserPlanType } from '@/users/domain/UserPlan';
import CheckUserPlanAccess from '@/finsight/ui/common/components/CheckUserPlanAccess';
import TileHeaderContent from '@/finsight/ui/components/trace/TraceTile/TileHeaderContent';

const tooltipContent = 'Analyze secondary market liquidity with timely and valuable trading data from '
    + 'TRACE by FINRA.';
const fallBack = <TraceTileFallback tooltipContent={ tooltipContent } />;

const TraceTileHeader = ({ withChart }) => (
  <CheckUserPlanAccess
    requiredUserPlan={ UserPlanType.PRO }
    fallback={ fallBack }
  >
    <TileHeaderContent withChart={ withChart } />
  </CheckUserPlanAccess>
);

export default TraceTileHeader;
